import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

import { ref, withDefaults, onMounted, watch } from 'vue';
	import translate from '@/api/translate';

	interface main {
		id ?: string | number,
		size ?: string,
		ValueKey ?: string,
		LabelKey ?: string,
		width ?: string | number,
		disabled ?: boolean,
	}
export default /*#__PURE__*/_defineComponent({
  __name: 'DisableEnableSelect',
  props: {
    id: { default: "" },
    size: { default: "default" },
    ValueKey: { default: "value" },
    LabelKey: { default: "label" },
    width: { default: "100%" },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:id", "change", "clear"],
  setup(__props: any, { emit: __emit }) {

	;

	const props = __props;

	const emits = __emit;
	const StatusId = ref<any>("");
	const StatusList = ref<any>([{
		value: 1,
		label: translate.ShowText('启用'), // 启用
	}, {
		value: 0,
		label: translate.ShowText('禁用'), // 禁用
	}]);
	const placeholder = ref(translate.ShowText('请选择状态')); // 请选择状态

	watch(() => props.id, (n : any) => {
		StatusId.value = n;
	});

	onMounted(() => {
		StatusId.value = props.id;
	});

	const StatusChange = (data : any) => {
		emits("update:id", data);
		emits("change", data);
	};
	const StatusClear = () => {
		emits("clear");
	};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    "remote-show-suffix": "",
    style: _normalizeStyle({'width': `${_ctx.width}`}),
    disabled: _ctx.disabled,
    size: _ctx.size,
    modelValue: StatusId.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((StatusId).value = $event)),
    placeholder: placeholder.value,
    onChange: StatusChange,
    onClear: StatusClear
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(StatusList.value, (v) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: v[_ctx.ValueKey],
          label: v[_ctx.LabelKey],
          value: v[_ctx.ValueKey]
        }, null, 8, ["label", "value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["style", "disabled", "size", "modelValue", "placeholder"]))
}
}

})